enum Disposition  {
    Patiente = 1,
    Enseignant = 2,
    SelectionEnvironnement = 3,
    DebriefEnvironnement = 4,
    DialogueQuestionEchange = 5,
    DialogueEchange = 6,
    DebriefEchange = 7,
    DialogueEchangeApprenant = 8
}

export {
    Disposition
};